import styled from "styled-components";

export const ContainerCardLisGhe = styled.div`
 display: flex;
 align-items: center;
 width: 100%;


`;

export const BodyCardListGhe = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  padding: 16px 24px;
  height: 50px;
  background: #f9fafb;
  border-radius: 8px;
  margin: 8px;
  border-bottom: 1px solid #eaecf0;

  @media screen and (max-width: 670px) {
    flex-direction: column;
    height: auto;
  }
`;

export const SubContentCardList = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 670px) {
  margin-bottom: 10px;
  }
`;
